import * as React from 'react';
import { IgcChipComponent as Component } from 'igniteui-webcomponents';
import type { IgcChipComponentEventMap } from 'igniteui-webcomponents';
import { type EventName, createComponent } from '../react-props.js';

/**
 * Chips help people enter information, make selections, filter content, or trigger actions.
 * @slot  - Renders content in the default slot of the chip.
 * @slot prefix - Renders content at the start of the chip, before the default content.
 * @slot suffix - Renders content at the end of the chip after the default content.
 * @slot select - Content to render when the chip in selected state.
 * @slot remove - Content to override the default remove chip icon.
 * @fires igcRemove - Emits an event when the chip component is removed. Returns the removed chip component.
 * @fires igcSelect - Emits event when the chip component is selected/deselected and any related animations and transitions also end.
 * @csspart base - The base wrapper of the chip.
 * @csspart content - The wrapper element around the default slot of the chip.
 * @csspart prefix - The prefix container of the chip.
 * @csspart suffix - The suffix container of the chip.
 * @class
 */
export const IgrChip = /* @__PURE__ */ createComponent({
  tagName: 'igc-chip',
  displayName: 'IgrChip',
  elementClass: Component,
  react: React,
  events: {
    onRemove: 'igcRemove' as EventName<IgcChipComponentEventMap['igcRemove']>,
    onSelect: 'igcSelect' as EventName<IgcChipComponentEventMap['igcSelect']>,
  },
});

export type IgrChip = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrChipModule = Component;
